export class Adr {
  classe: string;
  codeDanger: string;
  codeHecate: 0;
  codeTunnels: string;
  designation: string;
  groupeEmballage: string;
  id: 0;
  numeroUN: 0;
  constructor(classe: string, codeDanger: string, codeHecate: 0, codeTunnels: string, designation: string, groupeEmballage: string, id: 0, numeroUN: 0) {
    this.classe = classe;
    this.codeDanger = codeDanger;
    this.codeHecate = codeHecate;
    this.codeTunnels = codeTunnels;
    this.designation = designation;
    this.groupeEmballage = groupeEmballage;
    this.id = id;
    this.numeroUN = numeroUN;
  }
}
